import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import Loader from "../libs/loader.jsx";


import createEngine, { 
    DefaultLinkModel, 
    DefaultNodeModel,
    DefaultPortModel,
    DiagramModel ,
    PathFindingLinkFactory
} from '@projectstorm/react-diagrams';

import {CanvasWidget} from '@projectstorm/react-canvas-core';
import {PortModelAlignment} from "@projectstorm/react-diagrams-core"

class DataRelations extends React.Component
{
    constructor(props)
    {
        //console.log('constructor');
        super(props);
        
        //console.log(this.props.dataset);
        
        this.state = {
            //nodes: [],
        };
        
        this.engine = createEngine();
        this.model = new DiagramModel();
        this.engine.setModel(this.model);
        this.nodes=[];
        
        this.cache = {
            'tables': {},
            'items': [],
            'subitems-items': []
        };
        
        //create settings cache
        this.createCache();
        
        this.loader = React.createRef();
    }
    
    /**
     * Add table to cache if not exist.
     * @param string table_id
     * @returns {undefined}
     */
    cacheAddTable(table_id)
    {
        var this_component = this;
        if(!(table_id in this_component.cache.tables))
        {
            this_component.cache.tables[table_id] = {};
        }
    }
    
    /**
     * Add field to cache if not exist.
     * @param string table_id
     * @param string field_id
     * @param object field
     * @returns {undefined}
     */
    cacheAddField(table_id, field_id, field)
    {
        var this_component = this;
        if(!(table_id in this_component.cache.tables))
        {
            this_component.cache.tables[table_id] = {};
        }
        
        if(!(field_id in this_component.cache.tables[table_id]))
        {
            this_component.cache.tables[table_id][field_id] = field;
        }
    }
    
    /**
     * Add field to items fields cache and add tables if needed.
     * @param object field
     * @returns {undefined}
     */
    cacheAddItem(field, type)
    {
        var this_component = this;
        
        if(config && ('feed' in config) && ('fields' in config.feed) && (field.type in config.feed.fields)   )
        {
            var config_fields = config.feed.fields[field.type];
            
            _(config_fields).forEach( (config_field) => 
            {
                var item = {...field};
                
                var field_id = item.name.replace(/[\@\.\#]+/gi, '_');
                field_id = field_id+' ('+item.type+'_'+item.id+')';
                if('name' in config_field)
                {
                    field_id = field_id+': '+config_field.name;
                }
                if('relations' in config_field)
                {
                    item['relations'] = config_field['relations'];
                }
                item['field_id'] = field_id;
                
                if(['simple','combined'].includes(config_field.type))
                {
                    this_component.cache[type].push(item);
                }
                
                if(['table','combined'].includes(config_field.type) && ('table' in config_field) )
                {
                    this_component.cacheAddTable(config_field.table);
                }
            });
        }
        
    }
    
    /**
     * Create config cache with information which tables must be showed.
     * @returns {Boolean}
     */
    createCache()
    {
        var this_component = this;
    
        if( !( 'dataset' in this_component.props) || !( 'fields' in this_component.props.dataset) ) return false;
        
        _(Object.keys(this_component.props.dataset.fields)).forEach((table_id) => {
            
            var fields = this_component.props.dataset.fields[table_id];
            
            this_component.cacheAddTable(table_id);
            
            _(fields).forEach((field, index) => {
                
                //console.log('field',field);
                var config_field = false;
                
                if(config && ('feed' in config) && ('tables' in config.feed) && (table_id in config.feed.tables) && (field.name in config.feed.tables[table_id].fields)  )
                {
                    config_field = config.feed.tables[table_id].fields[field.name];
                    //console.log('config_field', config_field);
                }
                
                if(config_field && ('type' in config_field) && (config_field.type == 'table') && ('table' in config_field) )
                {
                    this_component.cacheAddTable(config_field.table);
                }
                
                if(config_field)
                {
                    this_component.cacheAddField(table_id, field.name, config_field);
                }
                else if(table_id == 'items')
                {
                    this_component.cacheAddItem(field, 'items');
                }
                else if(table_id == 'subitems-items')
                {
                    this_component.cacheAddItem(field, 'subitems-items');
                }
                
            });
            
        });
        //console.log('createCache', {...this_component.cache} );
        return true;
    }
    
    /**
     * Check show or not table.
     * @param string table_id Table name
     * @returns {Boolean}
     */
    skipTable(table_id)
    {
        var this_component = this;
        
        //if global schema - show all tables.
        if( !( 'dataset' in this_component.props) || !( 'fields' in this_component.props.dataset) ) return false;
        
        //if dataset schema - show only table which present in settings cache
        if( !(table_id in this_component.cache.tables) ) return true;
        
        return false;
    }
    
    /**
     * Check show or not field in table.
     * @param string table_id Table name
     * @param string field_id Field name
     * @returns {Boolean}
     */
    skipField(table_id, field_id)
    {
        var this_component = this;
        
        //if global schema - show all tables.
        if( !( 'dataset' in this_component.props) || !( 'fields' in this_component.props.dataset) ) return false;
        
        //if dataset schema - show only table which present in settings cache
        if( !(table_id in this_component.cache.tables) ) return true;
        
        //if dataset schema - show only fields which present in settings cache
        if( !(field_id in this_component.cache.tables[table_id]) ) return true;
        
        return false;
    }
    
    /**
     * Create  nodes and ports
     * @returns {undefined}
     */
    async createOveralModel()
    {
        var this_component = this;
        var model = this_component.model;
        
        if(config && ('feed' in config) && ('tables' in config.feed) )
        {
            _(Object.keys(config.feed.tables)).forEach((table_id) => {
                
                if(table_id == 'subitems-items') return true;
                else
                if(table_id == 'items')
                {
                    if( this_component.skipTable('items') && this_component.skipTable('subitems-items')) return true;
                }
                else
                if(this_component.skipTable(table_id)) return true;
                
                var table = config.feed.tables[table_id]
                
                if(table_id == 'items')
                {
                    //console.log('createOveralModel table', {...table});
                    table['default_fields'] = {...config.feed.tables['subitems-items']['default_fields'], ...table['default_fields'] };
                    table['fields'] = {...config.feed.tables['subitems-items']['fields'], ...table['fields'] };
                    //console.log('createOveralModel table', {...table});
                }
                
                var node = new DefaultNodeModel({
                    name: table.name,
                    id: table_id,
                });
                
                _(['default_fields','fields']).forEach( (fields_group) => 
                {
                    if(fields_group in table) _(Object.keys(table[fields_group])).forEach((field_id) =>
                    {
                        
                        var field = table[fields_group][field_id];
                        
                        if('type' in field) return;
                        
                        if(['fields'].includes(fields_group) && table_id == 'items')
                        {
                            //console.log(field_id, table, field, (this_component.skipField('items', field_id) && this_component.skipField('subitems-items', field_id)) );
                            if( this_component.skipField('items', field_id) && this_component.skipField('subitems-items', field_id)) return true;
                        }
                        else
                        if(['fields'].includes(fields_group) && this_component.skipField(table_id, field_id)) return;
                        
                        if(
                                table_id == 'items' && 
                                field_id == 'Parent ID' && 
                                (
                                    ('dataset' in this_component.props) &&
                                    ('fields' in this_component.props.dataset) && 
                                    !('subitems-items' in this_component.props.dataset.fields)
                                )
                        ) return;
                        
                        var label = field_id;
                        var port_field_id = field_id.replace(/[\s\(\)]+/gi,'_');
                        
                        //create port on left and right sides
                        var port = new DefaultPortModel({
                            in: true,
                            name: port_field_id,
                            label: label,
                            //alignment: PortModelAlignment.LEFT
                        });
                        node.addPort(port);
                        port.setLocked(true);
                        
                        var port = new DefaultPortModel({
                            in: false,
                            name: 'OUT_'+port_field_id,
                            label: '',
                            //alignment: PortModelAlignment.RIGHT
                        });
                        node.addPort(port);
                        port.setLocked(true);
                        //END create port on left and right sides

                    });
                });
                
                //add additional client fields
                if(table_id == 'items')
                {
                    _(['items','subitems-items']).forEach( (fields_group) => 
                    {
                        _(this_component.cache[fields_group]).forEach( (item) => 
                        {
                            var label = item.field_id;
                            var field_id = item.field_id.replace(/[\s\(\)]+/gi,'_');
                            //create port on left and right sides
                            var port = new DefaultPortModel({
                                in: true,
                                name: field_id,
                                label: label,
                                //alignment: PortModelAlignment.LEFT
                            });
                            node.addPort(port);
                            port.setLocked(true);

                            var port = new DefaultPortModel({
                                in: false,
                                name: 'OUT_'+field_id,
                                label: '',
                                //alignment: PortModelAlignment.RIGHT
                            });
                            node.addPort(port);
                            port.setLocked(true);
                        });
                    });
                }
                
                model.addAll(node);
                //this_component.engine.setModel(model);
                //this_component.nodes.push(node);
            });
        }
    }
    
    /**
     * Reposition nodes and create links between ports after reposition
     * @returns {Promise}
     */
    async createLinks()
    {
        var this_component = this;

        var model = this_component.model;
        var engine = this_component.engine;
            
        engine.repaintCanvas();
        
        return new Promise(resolve => {

            setTimeout( ()=> {
                
                
                //set nodes position calculated on their size
                const maxHeight=600;
                var currentMaxX=0;

                const paddingY = 50;
                const paddingX = 200;

                var startPositionX = 0;
                var startPositionY = 0;
                
                var nodes = model.getNodes();
                
                _(nodes).forEach( (node) => {

                    //console.log('node setPosition',{...node}, {...node.getPosition()});
                    node.setPosition( startPositionX, startPositionY );
                    //console.log('node setPosition',{...node}, {...node.getPosition()});

                    currentMaxX = (node.width > currentMaxX)? node.width : currentMaxX;

                    //console.log('startPositionX',startPositionX, 'startPositionY', startPositionY, 'currentMaxX', currentMaxX);

                    startPositionY = startPositionY + paddingY + node.height;

                    //console.log('startPositionY next',startPositionY);

                    if(startPositionY>=maxHeight)
                    {
                        startPositionX = startPositionX + paddingX + currentMaxX;
                        startPositionY = 0;
                        currentMaxX = 0;

                        //console.log('>, new startPositionX',startPositionX);
                    }
                    //console.log('node:', node);
                });
                //END set nodes position calculated on their size
                
                //Create links between nodes ports
                if(config && ('feed' in config) && ('tables' in config.feed) )
                {
                    _(Object.keys(config.feed.tables)).forEach((table_id) => {
                        
                        if(table_id == 'subitems-items') return true;
                        else
                        if(table_id == 'items')
                        {
                            if( this_component.skipTable('items') && this_component.skipTable('subitems-items')) return true;
                        }
                        else
                        if(this_component.skipTable(table_id)) return true;
                        
                        var table = config.feed.tables[table_id]

                        var from_node = model.getNode(table_id);

                        _(['default_fields','fields']).forEach( (fields_group) => {
                            if(fields_group in table) _(Object.keys(table[fields_group])).forEach((field_id) => {
                                var field = table[fields_group][field_id];
                                
                                //console.log(table_id, table, fields_group, field_id, field);
                                
                                if( ('type' in field)) return;
                                
                                var port_field_id = field_id.replace(/[\s\(\)]+/gi,'_');

                                if('relations' in field) _(field.relations).forEach( (relation) => {
                                    var to_node = model.getNode(relation.table);
                                    if(!to_node) return;

                                    var from_port,to_port;
                                    var port_relation_field = relation.field.replace(/[\s\(\)]+/gi,'_');
                                    //console.log('from_node',{...from_node}, {...from_node.getPosition()});
                                    //console.log('to_node',{...to_node}, {...to_node.getPosition()});

                                    if(from_node.getPosition().x === to_node.getPosition().x)
                                    {
                                        from_port = from_node.getPort('OUT_'+port_field_id);
                                        to_port = to_node.getPort('OUT_'+port_relation_field);
                                    }
                                    else if(from_node.getPosition().x < to_node.getPosition().x)
                                    {
                                        from_port = from_node.getPort('OUT_'+port_field_id);
                                        to_port = to_node.getPort(port_relation_field);
                                    }
                                    else if(from_node.getPosition().x > to_node.getPosition().x)
                                    {
                                        from_port = from_node.getPort(port_field_id);
                                        to_port = to_node.getPort('OUT_'+port_relation_field);
                                    }

                                    //console.log('from_port', {...from_port});
                                    //console.log('to_port', {...to_port});

                                    if(from_port && to_port)
                                    {
                                        var link = from_port.link(to_port);
                                        model.addAll( link );
                                        //console.log('link',{...link});
                                    }
                                });

                            });
                        });
                        
                        //add additional client fields
                        if(table_id == 'items')
                        {
                            _(['items','subitems-items']).forEach( (fields_group) => 
                            {
                                _(this_component.cache[fields_group]).forEach( (field) => 
                                {
                                    var label = field.field_id;
                                    var port_field_id = field.field_id.replace(/[\s\(\)]+/gi,'_');
                                    
                                    if('relations' in field) _(field.relations).forEach( (relation) => {
                                        
                                        //console.log(table_id, fields_group, port_field_id, field, relation);
                                        
                                        var to_node = model.getNode(relation.table);
                                        if(!to_node) return;

                                        var from_port,to_port;
                                        var port_relation_field = relation.field.replace(/[\s\(\)]+/gi,'_');
                                        //console.log('from_node',{...from_node}, {...from_node.getPosition()});
                                        //console.log('to_node',{...to_node}, {...to_node.getPosition()});

                                        if(from_node.getPosition().x === to_node.getPosition().x)
                                        {
                                            from_port = from_node.getPort('OUT_'+port_field_id);
                                            to_port = to_node.getPort('OUT_'+port_relation_field);
                                        }
                                        else if(from_node.getPosition().x < to_node.getPosition().x)
                                        {
                                            from_port = from_node.getPort('OUT_'+port_field_id);
                                            to_port = to_node.getPort(port_relation_field);
                                        }
                                        else if(from_node.getPosition().x > to_node.getPosition().x)
                                        {
                                            from_port = from_node.getPort(port_field_id);
                                            to_port = to_node.getPort('OUT_'+port_relation_field);
                                        }

                                        //console.log('from_port', {...from_port});
                                        //console.log('to_port', {...to_port});

                                        if(from_port && to_port)
                                        {
                                            var link = from_port.link(to_port);
                                            model.addAll( link );
                                            //console.log('link',{...link});
                                        }
                                    });
                                    
                                });
                            });
                        }
                        
                        

                    });
                }
                //END Create links between nodes ports
                
                engine.repaintCanvas();
                resolve(true);
                
            }, 300);
        });

    }
    
    async componentDidMount()
    {
        //console.log('componentDidMount');
        var this_component = this;
        
        this_component.loader.current.showLoader();
        
        await this_component.createOveralModel();
        
        await this_component.createLinks();
        
        var model = this_component.model;
        var engine = this_component.engine;
        
        model.setZoomLevel(120); 
        
        
        document.querySelector("#svg-pan-zoom-zoom-in").addEventListener("click", () => this_component.zoomIn());
        document.querySelector("#svg-pan-zoom-reset-pan-zoom").addEventListener("click", () => this_component.zoomReset());
        document.querySelector("#svg-pan-zoom-zoom-out").addEventListener("click", () => this_component.zoomOut());
        
        this_component.loader.current.hideLoader();
    }
    
    componentWillUnmount()
    {
        //console.log('componentWillUnmount');
    }
    
    componentDidUpdate()
    {
        //console.log('componentDidUpdate');
        var this_component = this;
        //this_component.createLinks();
    }
    
    zoomIn()
    {
        var this_component = this;
        var model = this_component.model;
        var engine = this_component.engine;
        
        model.setZoomLevel(model.getZoomLevel() + 5);
        engine.repaintCanvas();
    }
    
    zoomOut()
    {
        var this_component = this;
        var model = this_component.model;
        var engine = this_component.engine;
        
        model.setZoomLevel(model.getZoomLevel() - 5);
        engine.repaintCanvas();
    }
    
    zoomReset()
    {
        //console.log('zoomReset');
        var this_component = this;
        var model = this_component.model;
        var engine = this_component.engine;
        
        model.setZoomLevel(120);
        engine.repaintCanvas();
    }

    
    render()
    {
        //console.log('render');
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader} style={{'height': '100%'}}>
                <CanvasWidget engine={this_component.engine} className="diagram-widget-canvas" />
                <svg style={{'width': '100px', 'height':'100px', 'position':'absolute', 'bottom':'0px', 'right':'0px'}}>
                    <g id="svg-pan-zoom-controls" transform="translate(0 0) scale(0.75)" className="svg-pan-zoom-control">
                        <g id="svg-pan-zoom-zoom-in" transform="translate(30.5 5) scale(0.016)" className="svg-pan-zoom-control">
                            <rect x="0" y="0" width="1450" height="1450" className="svg-pan-zoom-control-background"></rect>
                            <path d="M1280 576v128q0 26 -19 45t-45 19h-320v320q0 26 -19 45t-45 19h-128q-26 0 -45 -19t-19 -45v-320h-320q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h320v-320q0 -26 19 -45t45 -19h128q26 0 45 19t19 45v320h320q26 0 45 19t19 45zM1536 1120v-960 q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5t84.5 -203.5z" className="svg-pan-zoom-control-element"></path>
                        </g>
                        <g id="svg-pan-zoom-reset-pan-zoom" transform="translate(5 35) scale(0.4)" className="svg-pan-zoom-control">
                            <rect x="2" y="2" width="182" height="58" className="svg-pan-zoom-control-background"></rect>
                            <path d="M33.051,20.632c-0.742-0.406-1.854-0.609-3.338-0.609h-7.969v9.281h7.769c1.543,0,2.701-0.188,3.473-0.562c1.365-0.656,2.048-1.953,2.048-3.891C35.032,22.757,34.372,21.351,33.051,20.632z" className="svg-pan-zoom-control-element"></path>
                            <path d="M170.231,0.5H15.847C7.102,0.5,0.5,5.708,0.5,11.84v38.861C0.5,56.833,7.102,61.5,15.847,61.5h154.384c8.745,0,15.269-4.667,15.269-10.798V11.84C185.5,5.708,178.976,0.5,170.231,0.5z M42.837,48.569h-7.969c-0.219-0.766-0.375-1.383-0.469-1.852c-0.188-0.969-0.289-1.961-0.305-2.977l-0.047-3.211c-0.03-2.203-0.41-3.672-1.142-4.406c-0.732-0.734-2.103-1.102-4.113-1.102h-7.05v13.547h-7.055V14.022h16.524c2.361,0.047,4.178,0.344,5.45,0.891c1.272,0.547,2.351,1.352,3.234,2.414c0.731,0.875,1.31,1.844,1.737,2.906s0.64,2.273,0.64,3.633c0,1.641-0.414,3.254-1.242,4.84s-2.195,2.707-4.102,3.363c1.594,0.641,2.723,1.551,3.387,2.73s0.996,2.98,0.996,5.402v2.32c0,1.578,0.063,2.648,0.19,3.211c0.19,0.891,0.635,1.547,1.333,1.969V48.569z M75.579,48.569h-26.18V14.022h25.336v6.117H56.454v7.336h16.781v6H56.454v8.883h19.125V48.569z M104.497,46.331c-2.44,2.086-5.887,3.129-10.34,3.129c-4.548,0-8.125-1.027-10.731-3.082s-3.909-4.879-3.909-8.473h6.891c0.224,1.578,0.662,2.758,1.316,3.539c1.196,1.422,3.246,2.133,6.15,2.133c1.739,0,3.151-0.188,4.236-0.562c2.058-0.719,3.087-2.055,3.087-4.008c0-1.141-0.504-2.023-1.512-2.648c-1.008-0.609-2.607-1.148-4.796-1.617l-3.74-0.82c-3.676-0.812-6.201-1.695-7.576-2.648c-2.328-1.594-3.492-4.086-3.492-7.477c0-3.094,1.139-5.664,3.417-7.711s5.623-3.07,10.036-3.07c3.685,0,6.829,0.965,9.431,2.895c2.602,1.93,3.966,4.73,4.093,8.402h-6.938c-0.128-2.078-1.057-3.555-2.787-4.43c-1.154-0.578-2.587-0.867-4.301-0.867c-1.907,0-3.428,0.375-4.565,1.125c-1.138,0.75-1.706,1.797-1.706,3.141c0,1.234,0.561,2.156,1.682,2.766c0.721,0.406,2.25,0.883,4.589,1.43l6.063,1.43c2.657,0.625,4.648,1.461,5.975,2.508c2.059,1.625,3.089,3.977,3.089,7.055C108.157,41.624,106.937,44.245,104.497,46.331z M139.61,48.569h-26.18V14.022h25.336v6.117h-18.281v7.336h16.781v6h-16.781v8.883h19.125V48.569z M170.337,20.14h-10.336v28.43h-7.266V20.14h-10.383v-6.117h27.984V20.14z" className="svg-pan-zoom-control-element"></path>
                        </g>
                        <g id="svg-pan-zoom-zoom-out" transform="translate(30.5 70) scale(0.016)" className="svg-pan-zoom-control">
                            <rect x="0" y="0" width="1450" height="1450" className="svg-pan-zoom-control-background"></rect>
                            <path d="M1280 576v128q0 26 -19 45t-45 19h-896q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h896q26 0 45 19t19 45zM1536 1120v-960q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5 t84.5 -203.5z" className="svg-pan-zoom-control-element"></path>
                        </g>
                    </g>
                </svg>
            </Loader>
        );
    }
}


DataRelations.defaultProps = {};

export default withRouter(DataRelations);
